import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../lib/api.service';
import { StorageService } from '../../../lib/storage.service';
import { LogService } from '../../../lib/log.service';
import { UtilityService } from '../../../lib/utility.service';
import { ModalService } from '../../../lib/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Organization } from '../../../models/organization';
import { AuthModuleService } from '../lib/auth-module.service';
import { LoginAPIService } from "../lib/login-api.services";
import { AnalyticEvent } from 'app/lib/analytic-event';
import { SafeRedirect } from '../../../lib/safe-redirect';

@Component({
    selector: 'register-form',
    templateUrl: './register-form.html',
    standalone: false
})
export class RegisterFormComponent implements OnInit {

	fullName: string;
	emailAddress: string;
	password: string;
	inputs: string[];
	exiting: boolean;
	errorPopup: any;
	successPopup: any;
	emptyPopup: any;
	showTerms: boolean;
	showNext: boolean;
	agree: boolean;
	sub: string;
	accesscode: string;
	code: any;
	logo = '';
	logoPath = '';
	suffix = '';
	tosPopup: any;
	organization: Organization;
	organizations: Organization[];
	orgId: number = -1;
	valid: boolean;
	skip: boolean = false;
	accessCode: string = '';
	orgEmail: string = '';
	redirect: string = '';
	passwordValidate: boolean = false;
	emailValidate: boolean = false;
	signUpText: any;
	name: string = '';
	domains: Array<string>;
	domain: string = '';
	emailPlaceholder: string;
	signUpStrings: any;
	customConfirm: string = '';
	customConfirmCheck: boolean = false;

	@Input() title: string;
	@Input() description: string;
	passwordType:string = 'password';
	constructor(
		private api: ApiService,
		private modalService: ModalService,
		private storage: StorageService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private log: LogService,
		private translate: TranslateService,
		private authCommon: AuthModuleService,
		private loginApi: LoginAPIService) {

		this.exiting = true;
		this.errorPopup = {};
		this.successPopup = {};
		this.emptyPopup = {};

		this.inputs = [];

		this.agree = false;
		this.showTerms = false;
	}

	ngOnInit() {
		this.translate.stream('signUp').subscribe((res: any) => {
			this.signUpText = res;
			this.inputs = res.inputs;
			this.errorPopup = res.errorPopup;
			this.successPopup = res.successPopup;
			this.emptyPopup = res.emptyPopup;
			this.tosPopup = res.tosPopup;
			this.signUpStrings = res;
			this.emailPlaceholder = this.signUpStrings.emailPlaceholder;
		});

		this.activatedRoute.queryParams.subscribe(params => {
			this.code = params['code'] ? params['code'] : '';
			this.accesscode = params['accesscode'] ? params['accesscode'] : '';

			if(this.accesscode){
				this.router.navigate(['/'], { queryParams: { accesscode: this.accesscode } });
			}

			if (this.code) {
				this.loginApi.confirmGuid(this.code).subscribe(
					(results: any) => {
						let confirm = results.data[0];
						this.emailAddress = confirm.Arg1;
					});
			}
		});

		this.sub = UtilityService.getSubdomain();
		if (this.sub == 'app' || this.sub == 'staging') {
			this.sub = '';
		}

		if (this.sub || this.accesscode) {
			this.api.get('organizations', {
				Subdomain: this.sub,
				AccessCode: this.accesscode
			}).subscribe(
				(results: any) => {
					this.organization = new Organization(results.data);
					this.refreshOrg();
					this.applyChildOrganizationOptions(results.data);
				},
				(error: any) => {

				}
			);
		}
	}

	refreshOrg() {

		if (this.organization.allowedDomains != null && this.organization.allowedDomains !== '' && this.organization.enforceDomains) {
			this.emailPlaceholder = this.signUpStrings.emailPrefixPlaceholder;
			let domains = this.organization.allowedDomains.split(",");
			if (domains.length > 1) {
				this.domains = domains;
				this.suffix = '@';
			}
			else {
				this.suffix = '@' + this.organization.allowedDomains;
			}
		}

		if (this.organization.logoPath) {
			this.logoPath = this.organization.logoPath;
		}

		if (this.organization.name) {
			this.name = this.organization.name;
		}

		if (this.organization.settings['customConfirm']) {
			this.customConfirm = this.organization.settings['customConfirm'];
		}
	}

	onChangePassword() {
		let validate = this.authCommon.validatePassword(this.password);
		if (validate) {
			this.passwordValidate = true;
		}
		else {
			this.passwordValidate = false;
		}
	}

	onChangeEmail() {
		let validate = this.authCommon.validateEmail(this.emailAddress);
		if (validate) {
			this.emailValidate = true;
		}
		else {
			this.emailValidate = false;
		}
	}

	onpreSignUp() {
		if (!this.authCommon.validatePassword(this.password) && this.password) {
			this.modalService.showAlert(this.signUpText.passwordPopup.title, this.signUpText.passwordPopup.body);
			return;
		}

		if (this.domains && this.domain === '') {
			this.modalService.showAlert(this.signUpText.domainPopup.title, this.signUpText.domainPopup.body);
			return;
		}

		// Only require a campus choice when the selector is actually on screen with
		// options to pick. It lives inside the !showNext step and renders per
		// organizations?.length, so gate the guard on the same conditions - otherwise
		// a lingering (or empty) list demands an orgId the user can't see or select.
		if (!this.showNext && this.organizations && this.organizations.length && this.orgId === -1) {
			this.modalService.showAlert(this.signUpText.organizationPopup.title, this.signUpText.organizationPopup.body);
			return;
		}

		/*
		* support variable number of consent checks
		*/

		let consent = 1;
		let consentChecks = 0;

		if (this.customConfirm) {
			consent++;
		}

		if (!this.agree) {
			this.modalService.showAlert(this.signUpText.tosPopup.oops, this.signUpText.tosPopup.tos);
		}
		else {
			consentChecks++;
		}


		if (this.customConfirm) {
			if (!this.customConfirmCheck && this.agree) {
				this.modalService.showAlert(this.signUpText.tosPopup.oops, this.signUpText.tosPopup.tos);
			}
			else {
				consentChecks++;
			}
		}

		if (consentChecks < consent) {
			return;
		}

		//validate
		if (!this.emailAddress || !this.password || !this.fullName) {
			this.modalService.showAlert(this.signUpText.emptyPopup.title, this.signUpText.emptyPopup.body);
			return;
		}

		if (this.accesscode && this.orgEmail) {
			this.modalService.showAlert(this.signUpText.errorPopup.title, this.signUpText.registrationPopup.oneOrOther);
			return;
		}

		if (this.showNext && !this.skip && !this.accesscode && !this.orgEmail) {
			this.modalService.showAlert(this.signUpText.errorPopup.title, this.signUpText.registrationPopup.body);
			return;
		}

		let email;
		if (this.orgEmail) {
			email = this.orgEmail;
		}
		else if (this.suffix) {
			if (this.domain) {
				email = this.emailAddress + '@' + this.domain;
			}
			else {
				email = this.emailAddress + this.suffix;
			}
		}
		else {
			email = this.emailAddress;
		}

		this.loginApi.usersPreregistration(
			this.fullName,
			this.password,
			// accessCode (capital C) is never assigned; the form binds accesscode,
			// so a typed code used to be posted as an empty string and dropped.
			this.accesscode,
			this.sub,
			this.code,
			email,
			this.skip,
			this.orgId).subscribe(
			(data: any) => {
				this.modalService.showAlert(this.successPopup.title, data.message);
				this.log.event(AnalyticEvent.event.register);
				this.storage.resetFlags();
				this.router.navigate(['/']);
			},
			(error: any) => {
				if (error.status === 303) {
					this.api.get('organizations', {
						Email: email
					}, false).subscribe(
						(result: any) => {
							this.organization = new Organization(result.data);
							SafeRedirect.go(this.organization.sso, true);
						}
					);
				}
				else if (error.status === 404 && !this.showNext) {
					this.showNext = true;
				}
				else if (error.status === 412) {
					this.modalService.showAlert(this.signUpText.chooseOrganization.title, this.signUpText.chooseOrganization.body);
					this.loadOrganizationChoices(email);
				}
				else {
					this.modalService.showAlert(this.errorPopup.title, error.message);
					this.log.error('Error registering. ' + error.message);
				}
			}
		);
	}

	/**
	 * A subdomain or access code can land on a parent that has several active
	 * children, in which case it cannot tell us which one the user belongs to.
	 * Feed the options into the same field the domain path uses, so the selector
	 * and the required-choice guard in onpreSignUp() both apply.
	 */
	applyChildOrganizationOptions(data: any) {
		if (!data?.childOrganizationOptions?.length) {
			return;
		}

		this.organizations = Organization.initializeArray(data.childOrganizationOptions);

		// An earlier lookup can leave a selection that is not one of these options;
		// the server rejects a child its parent does not own.
		if (!this.organizations.some(org => org.id === this.orgId)) {
			this.orgId = -1;
		}
	}

	/**
	 * The server refused to guess which organization this signup belongs to.
	 *
	 * The subdomain or access code names its own parent, so ask that parent for
	 * its children. organizations/all only searches allowedDomains, and returns
	 * nothing when the user's email domain is not one of them - which left the
	 * user with the alert and an empty selector.
	 */
	loadOrganizationChoices(email: string) {
		if (!this.accesscode && !this.sub) {
			this.loadOrganizationsByDomain(email);
			return;
		}

		const params = this.accesscode
			? { AccessCode: this.accesscode }
			: { Subdomain: this.sub };

		this.api.get('organizations', params, false).subscribe(
			(result: any) => {
				if (result.data?.childOrganizationOptions?.length) {
					this.applyChildOrganizationOptions(result.data);
					return;
				}
				this.loadOrganizationsByDomain(email);
			},
			(error: any) => {
				this.loadOrganizationsByDomain(email);
			}
		);
	}

	private loadOrganizationsByDomain(email: string) {
		this.api.get('organizations/all', {
			Email: email,
			allowed: true
		}).subscribe(
			(result: any) => {
				this.organizations = Organization.initializeArray(result.data);
			}
		);
	}

	onPrevious() {
		this.showNext = false;
		// Clear any campus list so stepping back doesn't resurrect the child selector.
		// A real association reissues the 412 and repopulates it on resubmit.
		this.organizations = null;
		this.orgId = -1;
	}

	onClickPassword(){
		this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
	}

}
